// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimEventService} from "@services";
import {from, Observable} from "rxjs";
import {Event} from "@models";

@Pipe({
	name: "getEventById",
	standalone: false,
})
export class GetEventByIdPipe implements PipeTransform {
	constructor(private _simEventService: SimEventService) {}

	transform(value: string, ...args: unknown[]): Observable<Event> {
		if (value) {
			return from(this._simEventService.getEventById(value));
		}
		return null;
	}
}
